/*
 * File: input-number.ts
 * File Created: 2024-01-14 10:54:46
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 07:16:52
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { PropInnateSync } from "@root/core/vue-props";
import { BaseInputComponent } from "../core/lib/base-input-component";

@Component
export default class InputNumber extends BaseInputComponent {
    @PropInnateSync("value", {
        type: Number,
        validator: (value: number) => {
            if (isNaN(value)) {
                console.error(`<${value}> is not a valid value for <iv-input-number>.`);
            }
            return true;
        },
        default: null,
    })
    innateValue!: number | null;

    @Prop({ type: Number, default: 3 })
    decimal!: number;
}
